import { NgModule, Injector } from '@angular/core';
import { BaseModule } from '../base/base.module';
import { TimeSlotsComponent } from './components/time-slots/time-slots.component';
import { PatientCardComponent } from './components/card-layouts/patient-card/patient-card.component';
import { BedManagementComponent } from './components/bed-management/bed-management.component';
import { TrackStatusComponent } from './components/track-status/track-status.component';
import { PerPatientTrackStatusComponent } from './components/per-patient-track-status/per-patient-track-status.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PatientLayoutComponent } from './components/card-layouts/patient-layout/patient-layout.component';
import { PatientBillingComponent } from './components/card-layouts/patient-billing/patient-billing.component';
import { PaymentDetailComponent } from './components/payment-detail/payment-detail.component';
import { ViewCountGridComponent } from './components/view-count-grid/view-count-grid.component';
import { NhcxAuthorizationComponent } from './components/nhcx-authorization/nhcx-authorization.component';
import { InsuranceBillingComponent } from './components/insurance-billing/insurance-billing.component';
import { InsuranceBillingFormGridComponent } from './components/insurance-billing-form-grid/insurance-billing-form-grid.component';
import { DepositRefundBannerComponent } from './components/card-layouts/deposit-refund-banner/deposit-refund-banner.component';
import { IndentIssueComponent } from './components/indent-issued/indent-issue.component';
import { EMRPatientLayoutComponent } from './components/card-layouts/emr-patient-layout/emr-patient-layout.component';
import { OtSlotsComponent } from './components/ot-appointment/ot-slots.component';
import { ViewPrescriptionComponent } from './components/view-prescription/view-prescription.component';
import { SampleTrackComponent } from './components/sample-track/sample-track.component';
import { ReviewOrderComponent } from './components/review-order/review-order.component';
import { ReviewOrderModalComponent } from './components/review-order-modal/review-order-modal.component';
import { PaymentStatusComponent } from './components/payment-status/payment-status.component';
import { RefundComponent } from './components/refund/refund.component';
import { QueueViewComponent } from './components/queue-view/queue-view.component';
import { ImageUploadPopupComponent } from './components/image-upload-popup/image-upload-popup.component';
import { DoctorCardComponent } from './components/card-layouts/doctor-card/doctor-card.component';
import { AppService } from '../base/shared/services/app.service';
import { PatientViewQueueComponent } from './components/patient-view-queue/patient-view-queue.component';
import { PaytmRedirectComponent } from './components/paytm-redirect/paytm-redirect.component';
import { ProfileComponent } from './components/profile/profile.component';
import { PrescriptionPrintComponent } from './components/prescription-print/prescription-print.component';
import { OrdersCardViewComponent } from './components/orders-card-view/orders-card-view.component';
import { ShowStatusComponent } from './components/show-status/show-status.component';
import { PolylineComponent } from '../ambulance/components/polyline/polyline.component';
import { DoctorListComponent } from './components/doctor-list-video-call/doctor-list.component';
import { GenerateTokenComponent } from './components/generate-token/generate-token.component';
import { ViewTokenComponent } from './components/generate-token/view-token/view-token.component';
import { PatientUhidMergeComponent } from './components/patient-uhid-merge/patient-uhid-merge.component';
import { OtpInputComponent } from './components/otp-input/otp-input.component';
import { ReportDataTableComponent } from './components/report-data-table/report-data-table.component';
import { CounsellingComponent } from './components/counselling/counselling.component';
import { PaymentModeExtendedComponent } from './components/extendedPaymentMode/payment-mode-extended.component';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AmbulanceDocumentComponent } from './components/ambulance-document/ambulance-document.component';
import { AdvanceMisComponent } from './components/advance-mis/advance-mis.component';
import { CSVReaderComponent } from './components/csvreader/csvreader.component';
import { OnboardingFormGridComponent } from './components/onboarding-form-grid/onboarding-form-grid.component';
import { ViewValuesetsComponent } from './components/view-valuesets/view-valuesets.component';
import { SupportComponent } from './components/support/support.component';
import { EmrDietPlanComponent } from '../emr/components/emr-diet-plan/emr-diet-plan.component';
import { GenericProfileComponent } from './components/generic-profile/generic-profile.component';
import { CoverSheetComponent } from './components/cover-sheet/cover-sheet.component';
import { CoPayerPharmacyComponent } from '../pharmacy/component/co-payer-pharmacy/co-payer-pharmacy.component';
import { MarkFlagsComponent } from './components/mark-flags/mark-flags.component';
import { AiAgentRegistryComponent } from './components/ai-agent-registry/ai-agent-registry.component';
import { AiGuidedSetupWizardComponent } from './components/ai-agent-registry/ai-guided-setup-wizard.component';
import { AgentTriggerEditorComponent } from './components/ai-agent-registry/agent-trigger-editor.component';
import { TrackOrderComponent } from './components/track-order/track-order.component';
import { OtSlotsViewComponent } from './components/ot-appointment/ot-slots-view/ot-slots-view.component';
import { SystemBotComponent } from './components/system-bot/system-bot.component';
import { PatientBotComponent } from './components/patient-bot/patient-bot.component';
import { CounsellingPackageDetailingComponent } from './components/counselling-package-detailing/counselling-package-detailing.component';
import { MisDynamicGirdComponent } from './components/mis-dynamic-gird/mis-dynamic-gird.component';
import { HdfcPaymentStatusComponent } from './components/payment-status/hdfc-payment-status/hdfc-payment-status.component';
import { OtTransportDetailsComponent } from './components/ot-appointment/ot-transport-details/ot-transport-details.component';
import { FinanceComponentComponent } from './components/ot-appointment/finance-component/finance-component.component';
import { BedDashboardComponent } from './components/bed-dashboard/bed-dashboard.component';
import { DutyRoasterComponent } from './components/duty-roaster/duty-roaster.component';
import { DemographicOtpVerifyComponent } from './components/demographic-otp-verify/demographic-otp-verify.component';
import { PackageTokenScreenComponent } from './components/package-token-screen/package-token-screen.component';
import { ParTokenScreenComponent } from './components/par-token-screen/par-token-screen.component';
import { DynamicDataGridComponent } from './components/dynamic-data-grid/dynamic-data-grid.component';
import { OpItemConsumptionPayerComponent } from '../payment/components/op-item-consumption-payer/op-item-consumption-payer.component';
import { OtSurgeryDetailComponent } from './components/ot-appointment/ot-surgery-detail/ot-surgery-detail.component';
import { ViewPaymentDetailComponent } from './components/view-payment-detail/view-payment-detail.component';
import { AbhaCardComponent } from './components/abha-card/abha-card.component';
import { PopupConfirmComponent } from './components/popup-confirm/popup-confirm.component';
import { ReschedulepackageslotComponent } from './components/reschedulepackageslot/reschedulepackageslot.component';
import { ShowKitInfoComponent } from '../payment/components/show-kit-info/show-kit-info.component';
import { ExtendedSearchComponentComponent } from './components/extended-search-component/extended-search-component.component';
import { TokenApptQmsComponent } from './components/token-appt-qms/token-appt-qms/token-appt-qms.component';
import { SharedUEngineComponent } from './components/shared-u-engine/shared-u-engine.component';
import { PaymentDetailEditBillComponent } from './components/payment-detail-edit-bill/payment-detail-edit-bill.component';
import { MyFeedsComponent } from './components/my-feeds/my-feeds.component';
import { PackageServiceItemPopUpComponent } from './components/ot-appointment/package-service-item-pop-up/package-service-item-pop-up.component';
import { DietMealItemComponent } from './components/diet-meal-item/diet-meal-item.component';
import { OtTemplateViewComponent } from './components/ot-template-view/ot-template-view.component';
import { HDRDataComponent } from '../hdr-data/hdr-data.component';
import { AppointmentTokenTvViewComponent } from './components/generate-token/appointment-token-tv-view/appointment-token-tv-view.component';
import { MobileCardViewComponent } from './components/mobile-card-view/mobile-card-view.component';
import { ConferenceDashboardComponent } from '../emr/components/confrence/conference-dashboard.component';
import { SafeUrl } from '../emr/components/confrence/safeurl.pipe';
// import { CarePlanComponent } from '../care-plan/care-plan/care-plan.component';
import { SingleViewTokenComponent } from './components/generate-token/single-view-token/single-view-token.component';
import { TokenPopUpViewComponent } from './components/generate-token/token-pop-up-view/token-pop-up-view.component';
import { HealthAnalysisComponent } from './components/health-analysis/health-analysis.component';
import { DietPlanHistoryComponent } from './components/diet-plan-history/diet-plan-history.component';
import { CashDenominationComponent } from './components/cash-denomination/cash-denomination.component';
import { ConsentFormComponent } from './components/consent-form/consent-form.component';
import { FacilityUserOnboardingComponent } from './components/facility-user-onboarding/facility-user-onboarding.component';
import { ShowPackageConsumedItemsComponent } from '../payment/components/show-package-consumed-items/show-package-consumed-items.component';
import { SignatureTopazPadComponent } from './components/signature-topaz-pad/signature-topaz-pad.component';

// import { SafeUrl } from './components/confrence/safeurl.pipe';

@NgModule({
  declarations: [
    PaymentDetailEditBillComponent,
    OpItemConsumptionPayerComponent,
    CoPayerPharmacyComponent,
    TimeSlotsComponent,
    PopupConfirmComponent,
    PatientCardComponent,
    BedManagementComponent,
    BedDashboardComponent,
    TokenPopUpViewComponent,
    TrackStatusComponent,
    PerPatientTrackStatusComponent,
    PatientLayoutComponent,
    PatientBillingComponent,
    PaymentDetailComponent,
    ViewCountGridComponent,
    NhcxAuthorizationComponent,
    SharedUEngineComponent,
    InsuranceBillingComponent,
    InsuranceBillingFormGridComponent,
    DepositRefundBannerComponent,
    IndentIssueComponent,
    EMRPatientLayoutComponent,
    MobileCardViewComponent,
    OtSlotsComponent,
    ViewPrescriptionComponent,
    SampleTrackComponent,
    ReviewOrderComponent,
    ReviewOrderModalComponent,
    PaymentStatusComponent,
    RefundComponent,
    QueueViewComponent,
    ImageUploadPopupComponent,
    DoctorCardComponent,
    PatientViewQueueComponent,
    PaytmRedirectComponent,
    ProfileComponent,
    AppointmentTokenTvViewComponent,
    PrescriptionPrintComponent,
    CounsellingPackageDetailingComponent,
    PatientUhidMergeComponent,
    OrdersCardViewComponent,
    ShowStatusComponent,
    PolylineComponent,
    DoctorListComponent,
    GenerateTokenComponent,
    ViewTokenComponent,
    OtpInputComponent,
    ReportDataTableComponent,
    CounsellingComponent,
    PaymentModeExtendedComponent,
    AmbulanceDocumentComponent,
    AdvanceMisComponent,
    CSVReaderComponent,
    OnboardingFormGridComponent,
    ViewValuesetsComponent,
    SupportComponent,
    EmrDietPlanComponent,
    GenericProfileComponent,
    CoverSheetComponent,
    MyFeedsComponent,
    MarkFlagsComponent,
    AiAgentRegistryComponent,
    AiGuidedSetupWizardComponent,
    AgentTriggerEditorComponent,
    TrackOrderComponent,
    OtSlotsViewComponent,
    SystemBotComponent,
    PatientBotComponent,
    MisDynamicGirdComponent,
    HdfcPaymentStatusComponent,
    OtTransportDetailsComponent,
    HDRDataComponent,
    FinanceComponentComponent,
    DutyRoasterComponent,
    DemographicOtpVerifyComponent,
    PackageTokenScreenComponent,
    ParTokenScreenComponent,
    DynamicDataGridComponent,
    OtSurgeryDetailComponent,
    ViewPaymentDetailComponent,
    AbhaCardComponent,
    ReschedulepackageslotComponent,
    ShowKitInfoComponent,
    ExtendedSearchComponentComponent,
    TokenApptQmsComponent,
    MyFeedsComponent,
    ConferenceDashboardComponent,
    PackageServiceItemPopUpComponent,
    DietMealItemComponent,
    // CarePlanComponent,
    SingleViewTokenComponent,
    OtTemplateViewComponent,
    SafeUrl,
    HealthAnalysisComponent,
    DietPlanHistoryComponent,
    CashDenominationComponent,
    ConsentFormComponent,
    ShowPackageConsumedItemsComponent,
    FacilityUserOnboardingComponent,
    SignatureTopazPadComponent
  ],
  providers: [
    // {
    //   deps: [AppService],
    //   provide: AngularAgoraRtcService,
    //   useClass: TelemedicineServiceService
    // },
  ],
  imports: [
    BaseModule,
    FormsModule,
    ReactiveFormsModule,
    CarouselModule.forRoot()
  ],
  exports: [
    PaymentDetailEditBillComponent,
    OpItemConsumptionPayerComponent,
    CoPayerPharmacyComponent,
    BaseModule,
    TimeSlotsComponent,
    TokenPopUpViewComponent,
    PatientCardComponent,
    PatientLayoutComponent,
    BedManagementComponent,
    TrackStatusComponent,
    PerPatientTrackStatusComponent,
    PatientBillingComponent,
    DepositRefundBannerComponent,
    PaymentDetailComponent,
    ViewCountGridComponent,
    NhcxAuthorizationComponent,
    SharedUEngineComponent,
    InsuranceBillingComponent,
    InsuranceBillingFormGridComponent,
    EMRPatientLayoutComponent,
    ViewPrescriptionComponent,
    PopupConfirmComponent,
    RefundComponent,
    ImageUploadPopupComponent,
    DietMealItemComponent,
    DoctorCardComponent,
    AppointmentTokenTvViewComponent,
    PrescriptionPrintComponent,
    CounsellingPackageDetailingComponent,
    PatientUhidMergeComponent,
    PaymentStatusComponent,
    OrdersCardViewComponent,
    ShowStatusComponent,
    PolylineComponent,
    PatientViewQueueComponent,
    DoctorListComponent,
    OtpInputComponent,
    ReportDataTableComponent,
    OnboardingFormGridComponent,
    SupportComponent,
    EmrDietPlanComponent,
    GenericProfileComponent,
    CoverSheetComponent,
    // MobileCardViewComponent,
    MyFeedsComponent,
    MisDynamicGirdComponent,
    DynamicDataGridComponent,
    AbhaCardComponent,
    HealthAnalysisComponent,
    ViewPaymentDetailComponent,
    ReschedulepackageslotComponent,
    ShowKitInfoComponent,
    OtTemplateViewComponent,
    ExtendedSearchComponentComponent,
    TrackOrderComponent,
    DietPlanHistoryComponent,
    ConsentFormComponent,
    CashDenominationComponent,
    ShowPackageConsumedItemsComponent,
    FacilityUserOnboardingComponent,
    SignatureTopazPadComponent
  ]
})

export class KxSharedModule {
  public entryComponents:any =  [
    PaymentDetailEditBillComponent,
    OpItemConsumptionPayerComponent,
    CoPayerPharmacyComponent,
    PrescriptionPrintComponent,
    TokenPopUpViewComponent,
    CounsellingPackageDetailingComponent,
    PatientUhidMergeComponent,
    TimeSlotsComponent,
    PatientCardComponent,
    PatientLayoutComponent,
    DietMealItemComponent,
    PatientBillingComponent,
    BedManagementComponent,
    BedDashboardComponent,
    TokenApptQmsComponent,
    TrackStatusComponent,
    PerPatientTrackStatusComponent,
    PaymentDetailComponent,
    ViewCountGridComponent,
    NhcxAuthorizationComponent,
    AppointmentTokenTvViewComponent,
    InsuranceBillingComponent,
    OtTemplateViewComponent,
    InsuranceBillingFormGridComponent,
    DepositRefundBannerComponent,
    IndentIssueComponent,
    PopupConfirmComponent,
    EMRPatientLayoutComponent,
    OtSlotsComponent,
    OtTransportDetailsComponent,
    HDRDataComponent,
    ViewPrescriptionComponent,
    SampleTrackComponent,
    ReviewOrderComponent,
    ReviewOrderModalComponent,
    PaymentStatusComponent,
    RefundComponent,
    QueueViewComponent,
    ImageUploadPopupComponent,
    DoctorCardComponent,
    PatientViewQueueComponent,
    ProfileComponent,
    OrdersCardViewComponent,
    ShowStatusComponent,
    PolylineComponent,
    DoctorListComponent,
    GenerateTokenComponent,
    ViewTokenComponent,
    OtpInputComponent,
    ReportDataTableComponent,
    CounsellingComponent,
    PaymentModeExtendedComponent,
    AmbulanceDocumentComponent,
    AdvanceMisComponent,
    CSVReaderComponent,
    OnboardingFormGridComponent,
    ViewValuesetsComponent,
    SupportComponent,
    EmrDietPlanComponent,
    GenericProfileComponent,
    CoverSheetComponent,
    MyFeedsComponent,
    MobileCardViewComponent,
    MarkFlagsComponent,
    AiAgentRegistryComponent,
    AiGuidedSetupWizardComponent,
    TrackOrderComponent,
    PatientBotComponent,
    SystemBotComponent,
    MisDynamicGirdComponent,
    HdfcPaymentStatusComponent,
    FinanceComponentComponent,
    DutyRoasterComponent,
    DemographicOtpVerifyComponent,
    PackageTokenScreenComponent,
    ParTokenScreenComponent,
    DynamicDataGridComponent,
    OtSurgeryDetailComponent,
    AbhaCardComponent,
    ViewPaymentDetailComponent,
    SharedUEngineComponent,
    ReschedulepackageslotComponent,
    ShowKitInfoComponent,
    ExtendedSearchComponentComponent,
    TokenApptQmsComponent,
    ConferenceDashboardComponent,
    // CarePlanComponent,
    SingleViewTokenComponent,
    HealthAnalysisComponent,
    DietPlanHistoryComponent,
    ConsentFormComponent,
    FacilityUserOnboardingComponent,
    PackageServiceItemPopUpComponent,
    ShowPackageConsumedItemsComponent,
    CashDenominationComponent,
    SignatureTopazPadComponent
  ]

  public appService: AppService;
  constructor(public injector: Injector){
    this.appService = injector.get(AppService);
    this.appService._factories["modules"]["KxSharedModule"] = this.entryComponents;
    if( this.entryComponents &&  this.entryComponents.length){
      this.appService.buildFactory(this.entryComponents);
    }
  }
}

